if (!customElements.get('customer-reviews-slider')) {
  customElements.define(
    'customer-reviews-slider',
    class CustomerReviewsSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
        }
      }

      initSwiper() {
        const swiperContainer = this.querySelector('.swiper');
        if (!swiperContainer) return;

        const desktopCols = parseFloat(swiperContainer.dataset.desktopCols) || 2;
        const mobileCols = parseFloat(swiperContainer.dataset.mobileCols) || 1.15;
        const gapbetweenColsMobile = parseInt(swiperContainer.dataset.gapbetweenColsMobile) || 16;
        const gapbetweenColsDesktop = parseInt(swiperContainer.dataset.gapbetweenColsDesktop) || 24;
        const enableAutoplay = swiperContainer.dataset.enableAutoplay === 'true';
        const loop = swiperContainer.dataset.loop === 'true';
        const autoplaySpeed = parseInt(swiperContainer.dataset.autoplaySpeed) || 3000;

        const swiperOptions = {
          slidesPerView: mobileCols,
          spaceBetween: gapbetweenColsMobile,
          loop: loop,
          autoplay: enableAutoplay ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
          } : false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: desktopCols,
              spaceBetween: gapbetweenColsDesktop,
            }
          },
          grabCursor: true,
          autoHeight: false,
        };

        if (window.Swiper) {
          this.swiper = new window.Swiper(swiperContainer, swiperOptions);
        } else {
          // If Swiper is loaded asynchronously, wait for it
          document.addEventListener('DOMContentLoaded', () => {
            if (window.Swiper) {
              this.swiper = new window.Swiper(swiperContainer, swiperOptions);
            }
          });
        }
      }
    }
  );
}

